/* global BMS */
import {AMERICAN, DECIMAL, FRACTIONAL} from '../constants/identifiers';
import ODDS_LADDER from '../constants/configurations/oddsConfig';

export function getOddsFromOddsType(decimalOdds, selectedOddsType) {
    if (selectedOddsType) {
        switch (selectedOddsType) {
            case DECIMAL:
                return decimalOdds;
            case FRACTIONAL:
                return getOddsDecimalToFractional(decimalOdds);
            case AMERICAN:
                return getOddsDecimalToAmerican(decimalOdds);
            default:
                return;
        }
    }
}

// taken from odds-converter, odds lader was taken from rush horses go on inspired gitlab
// https://github.com/ryanwaits/odds-converter
function getOddsDecimalToFractional(decimal) {
    return (!process.env.NODE_ENV || process.env.NODE_ENV === 'development')
        ? fakeGetOddsDecimalToFractional(decimal)
        : BMS.getOddsDecimalToFractional(decimal);
}

function fakeGetOddsDecimalToFractional(decimal) {
    let fractional;

    let oddsLadder = ODDS_LADDER;

    if (decimal >= oddsLadder[0].decimal) {
        fractional = oddsLadder[0].fractional;
    } else if (decimal <= oddsLadder[oddsLadder.length - 1].decimal) {
        fractional = oddsLadder[oddsLadder.length - 1].fractional;
    } else {
        for (let i = 1; i < oddsLadder.length; i++) {
            if (decimal < oddsLadder[i - 1].decimal && decimal >= oddsLadder[i].decimal) {
                // in case of equi distance, return the bigger odd
                if ((oddsLadder[i - 1].decimal - decimal).toFixed(2) <= (decimal - oddsLadder[i].decimal).toFixed(2)) {
                    fractional = oddsLadder[i - 1].fractional;
                } else {
                    fractional = oddsLadder[i].fractional;
                }
                break;
            }
        }
    }
    return fractional;
}

function getOddsDecimalToAmerican(decimal) {
    return (!process.env.NODE_ENV || process.env.NODE_ENV === 'development')
        ? fakeGetOddsDecimalToAmerican(decimal)
        : BMS.getOddsDecimalToAmerican(decimal);
}

function fakeGetOddsDecimalToAmerican(decimal) {
    let american;
    if (decimal < 2.0) {
        american = ((-100) / (decimal - 1)).toPrecision(5);
    } else {
        american = ((decimal - 1) * 100).toPrecision(5);
    }
    return Math.round(american);
}

export function getOddsFromOperatorConfig(operatorOddsFormat) {
    if (operatorOddsFormat) {
        switch (operatorOddsFormat) {
            case 'Decimal':
                return DECIMAL;
            case 'Fractional':
                return FRACTIONAL;
            case 'American':
                return AMERICAN;
            default:
        }
    }
}



// WEBPACK FOOTER //
// ./src/helpers/oddsHelpers.js